import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["item", "handle"]
  static values = { url: String }

  connect() {
    this.sortable = new Sortable(this.element, {
      animation: 150,
      handle: "[data-document-folders--drag-target='handle']",
      draggable: "[data-document-folders--drag-target='item']",
      ghostClass: "opacity-50",
      chosenClass: "bg-gray-100",
      onChoose: this.handleChoose.bind(this),
      onUnchoose: this.handleUnchoose.bind(this),
      onEnd: this.handleDragEnd.bind(this),
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  handleChoose(event) {
    event.item.dataset.dragging = "true"
  }

  handleUnchoose(event) {
    delete event.item.dataset.dragging
  }

  handleDragEnd(event) {
    const item = event.item
    delete item.dataset.dragging

    // Skip reorder if the item was moved into another folder
    if (item.dataset.movedIntoFolder === "true") {
      delete item.dataset.movedIntoFolder
      return
    }

    const folderId = item.dataset.folderId
    const fileId = item.dataset.fileId
    const newPosition = event.newIndex + 1

    if (!this.urlValue) return

    const data = {
      position: newPosition,
    }

    if (folderId) {
      data.folder_id = folderId
    } else if (fileId) {
      data.file_id = fileId
    }

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        Accept: "text/vnd.turbo-stream.html, text/html, application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          console.error("Failed to update position")
          // Optionally revert the drag
        }
      })
      .catch((error) => {
        console.error("Error updating position:", error)
      })
  }
}
